import { useMemo } from "react";
import PropTypes from "prop-types";
import { Quote } from "lucide-react";
import { track } from "../utils/analytics";

import anaMariaDavePhoto from "../assets/ana-maria-dave.jpg";

function Testimonials({ items, title = "What couples are saying" }) {
  const data = useMemo(
    () =>
      items || [
        {
          id: "ana-maria-dave-2024-08-17",
          names: "Ana-Maria & Dave",
          location: "Clinton, WA",
          date: "Aug 17, 2024",
          role: "Wedding couple",
          photo: anaMariaDavePhoto,
          quote:
            "The main thing that can disrupt a wedding is inappropriate weather. Even though we planned an August wedding—the driest month on the island—forecasts started to predict clouds and even rain, and our ceremony was outside, so we shifted everything. That’s when I turned to Detelina (CTO and co-Founder of Climformatics). While other forecasts predicted rain, Climformatics predicted a dry day. And guess what? We had the sunniest, driest day—and the most beautiful photos.",
        },
      ],
    [items]
  );

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="section-container">
        <h2 className="section-title">{title}</h2>

        <ul className="testimonials-grid">
          {data.map((t) => (
            <li
              key={t.id}
              className="testimonial-card"
              onMouseEnter={() => track("testimonial_hover", { id: t.id })}
            >
              <figure>
                <div className="testimonial-media">
                  <img
                    loading="lazy"
                    src={t.photo}
                    alt={`${t.names} — ${t.location}, ${t.date}`}
                  />
                </div>

                <blockquote className="testimonial-quote">
                  <Quote aria-hidden className="quote-icon" size={28} />
                  <p>{t.quote}</p>
                </blockquote>

                <figcaption className="testimonial-meta">
                  <div className="testimonial-names">{t.names}</div>
                  <div className="testimonial-sub">
                    <span>{t.location}</span>
                    <span aria-hidden>•</span>
                    <span>{t.date}</span>
                    {t.role ? <span className="role"> — {t.role}</span> : null}
                  </div>
                </figcaption>
              </figure>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

Testimonials.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      names: PropTypes.string.isRequired,
      location: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      quote: PropTypes.string.isRequired,
      photo: PropTypes.string.isRequired,
      role: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};

export default Testimonials;
